import { previewCaptionTracks } from './captionTracks'

const URL_QUERY_OR_FRAGMENT_PATTERN = /[?#]/
const VIDEO_EXTENSION_PATTERN = /\.(m3u8|mp4|mov|m4v|webm|avi)$/

export function firstPreviewString(...values) {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim()
  }
  return undefined
}

export function isHlsPreviewUrl(url = '') {
  return String(url).includes('.m3u8')
}

function normalizeMetadata(metadata) {
  return metadata && typeof metadata === 'object' && !Array.isArray(metadata) ? metadata : {}
}

export function normalizePreviewMediaType(media = {}, url = '') {
  const explicitType = String(
    media.type ||
    media.asset_type ||
    media.assetType ||
    media.media_type ||
    ''
  ).toLowerCase()

  if (explicitType.includes('video')) return 'video'
  if (explicitType.includes('image')) return 'image'

  const normalizedUrl = String(url).split(URL_QUERY_OR_FRAGMENT_PATTERN)[0].toLowerCase()
  if (VIDEO_EXTENSION_PATTERN.test(normalizedUrl)) return 'video'
  return 'image'
}

export function normalizePostPreviewMedia(media) {
  if (!media) return null

  const metadata = normalizeMetadata(media.metadata)
  const hlsManifestUrl = firstPreviewString(
    media.hls_manifest_url,
    media.hlsManifestUrl,
    media.hls_url,
    media.hlsUrl,
    metadata.hls_manifest_url,
    metadata.hls_url,
    metadata.manifest_url,
    metadata.streaming_url,
  )
  const fallbackUrl = firstPreviewString(
    media.fallback_url,
    media.fallbackUrl,
    metadata.fallback_url,
    metadata.mp4_url,
  )
  const posterUrl = firstPreviewString(
    media.poster_url,
    media.posterUrl,
    media.thumbnail_url,
    media.thumbnailUrl,
    metadata.poster_url,
    metadata.thumbnail_url,
  )
  const url = firstPreviewString(
    media.previewUrl,
    media.preview_url,
    media.url,
    media.media_url,
    media.external_url,
    media.source_url,
    hlsManifestUrl,
    fallbackUrl,
    metadata.url,
    metadata.media_url,
    metadata.external_url,
    metadata.source_url,
    metadata.image_url,
    metadata.file_url,
    metadata.thumbnail_url,
  )

  if (!url) return null

  const type = normalizePreviewMediaType(media, hlsManifestUrl || fallbackUrl || url)

  return {
    id: media.id || media.mediaId || media.asset_id || media.object_key || url,
    type,
    url: type === 'video' ? (hlsManifestUrl || fallbackUrl || url) : url,
    hls_manifest_url: hlsManifestUrl || (type === 'video' && isHlsPreviewUrl(url) ? url : undefined),
    fallback_url: fallbackUrl || (type === 'video' && !isHlsPreviewUrl(url) ? url : undefined),
    poster_url: posterUrl,
    metadata,
    // Feed-shaped tracks; `[]` (never absent) so a second pass over this
    // output keeps the result instead of falling back to stored metadata.
    captions: type === 'video' ? previewCaptionTracks(media) : [],
  }
}
